<div class="modal-header flex-shrink-0">
  <h4 class="modal-title"> {{headerPrompt ? (headerPrompt | translate) : ('selectArticlePopup.default.header' | translate)}} </h4>
</div>
<div class="modal-body pt-0 d-flex flex-column">
  <div class="modal-body-inner fixed-fluid flex-grow-1">
    <div class="dialog-panel fluid d-flex flex-column overflow-scrolling-touch">
      <table class="table table-hover flex-grow-0 flex-shrink-0" fixedHeader [virtual]="true">
        <thead>
          <tr class="d-flex w-100">
            <th class="d-block pe-4 flex-shrink-0 flex-grow-0" #headerImage>{{'selectArticlePopup.dataGrid.image' | translate}}</th>
            <th class="d-block pe-4" #headerNumber>{{'selectArticlePopup.dataGrid.article_number' | translate}}</th>
            <th class="d-block pe-4" #headerOwnNo>{{'selectArticlePopup.dataGrid.ownNo' | translate}}</th>
            <th class="d-block pe-4" #headerColor>{{'article.list.color' | translate}}</th>
            <th class="d-block flex-grow-1">{{'viewArticlesPopup.dataGrid.info' | translate}}</th>
            <th class="d-block" style="flex: 0 0 25px"></th>
            <th class="d-block" style="flex: 0 0 25px"></th>
            <th class="d-block" style="flex: 0 0 50px"></th>
          </tr>
        </thead>
      </table>
      <virtual-scroller #scroll class="flex-grow-1" [items]="sourceArticles" [enableUnequalChildrenSizes]="true">
        <table class="accessory-table table table-hover table-overflow-hidden fixed-layout">
          <tbody class="new-stacking-context" #container>
            <tr *ngFor="let article of scroll.viewPortItems"
                (click)="selectItem(article)"
                dbltap
                (dblClicked)="selectArticle(article)"
                (dblTapped)="selectArticle(article)">
              <td [attr.width.px]="headerImage.clientWidth" class="crop p-2">
                <div class="img" [ngStyle]="{'background-image':'url(' + getArticleImage(article) + ')'}"></div>
              </td>
              <td [attr.width.px]="headerNumber.clientWidth">
                <strong>{{getArticleNumber(article)}}</strong>
              </td>
              <td [attr.width.px]="headerOwnNo.clientWidth">
                <strong>{{getCustomArticleNumber(article)}}</strong>
              </td>
              <td [attr.width.px]="headerColor.clientWidth" [innerHTML]="getArticleColorValue(article)"></td>
              <td>{{getArticleDescription(article)}}</td>
              <td width="25px">
                <a href="https://www.wago.com/{{getArticleNumber(article)}}"
                   target="_blank"
                   tooltip
                   [tooltipText]="'sidebar.search.technical_info' | translate"
                   tooltipPosition="bottom">
                  <app-svg-icon type="information_circle" size="medium-small"/>
                </a>
              </td>
              <td width="25px">
                <a tooltip
                   [tooltipText]="'sidebar.search.add_to_collection' | translate"
                   tooltipPosition="bottom"
                   (click)="addArticleToArticleCollection(article)">
                  <app-svg-icon [type]="isArticleInCollection(article.identity) ? 'star-full' : 'star'" size="medium-small"/>
                </a>
              </td>
              <td width="50px">
                <button class="btn btn-sm"
                        [ngClass]="currentSelectedArticle && article === currentSelectedArticle ? 'btn-primary' : 'btn-primary'"
                        tooltip
                        [tooltipText]="'leftPanel.button.project' | translate"
                        tooltipPosition="bottom"
                        (click)="selectArticle(article)">
                  <app-svg-icon type="caret-right" size="medium-small"/>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </virtual-scroller>
    </div>
  </div>
</div>
<div class="modal-footer justify-content-between flex-shrink-0">
  <div class="form-check me-auto">
    <div *ngIf="useFavoritesCheckBoxVisible">
      <input class="form-check-input" type="checkbox" id="useFavoritesCheckBox" [(ngModel)]="useFavorites" (change)="updateSourceArticles()">
      <label class="form-check-label" for="useFavoritesCheckBox">{{'selectArticlePopup.label.use_favorite' | translate}}</label>
  </div>
  </div>
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-secondary btn-forward" (click)="skip()">{{'global.label.skip' | translate}}</button>
</div>
